import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  private baseURL: string;

  constructor(private http: HttpClient) {
    if (window.location.href.includes('localhost')) {
      this.baseURL = 'http://localhost:5002/';
    } else {
      this.baseURL = '';
    }
  }

  async getEncryptionKey(): Promise<{ keyId: string; encryptionKey: string }> {
    try {
      const response: any = await this.http
        .get(this.baseURL + 'busers/encryption-key')
        .toPromise();
      if (response.success && response.keyId && response.encryptionKey) {
        console.log('Encryption key received, keyId:', response.keyId);
        return {
          keyId: response.keyId,
          encryptionKey: response.encryptionKey,
        };
      }
      throw new Error('Failed to fetch encryption key');
    } catch (error) {
      console.error('Error fetching encryption key:', error);
      throw error;
    }
  }

  async encryptCredentials(
    email: string,
    password: string
  ): Promise<{ encryptedCredentials: string; keyId: string }> {
    try {
      const { keyId, encryptionKey } = await this.getEncryptionKey();

      const credentials = JSON.stringify({ email, password });
      console.log('Encrypting credentials with AES');

      const encrypted = CryptoJS.AES.encrypt(
        credentials,
        encryptionKey
      ).toString();

      if (!encrypted) {
        throw new Error('Encryption failed');
      }

      console.log('Encrypted credentials, length:', encrypted.length);
      return {
        encryptedCredentials: encrypted,
        keyId: keyId,
      };
    } catch (error) {
      console.error('Error encrypting credentials:', error);
      throw error;
    }
  }
}
